<template>
  <div
    id="twitch-login-modal"
    class="fixed z-50 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      />

      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span>

      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-sm sm:p-6">
        Om mee te kunnen doen met de veilingen moeten je jouw openstaande veilingen eerst afrekenen!

        <a
          href="/afrekenen"
          class="mt-2 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-purple-500 hover:bg-purple-600 text-base font-medium text-white sm:col-start-2 sm:text-sm w-full"
        >
          Afrekenen
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../Mixins/Modal';

export default {
  mixins: [Modal],
};
</script>
